import React, { Component } from "react";
import service from "../../core/service";
import { AppConstants } from "../../core/constants";
import * as yup from "yup";
import { toast } from "react-toastify";
import { userData } from "../../Redux/services/generalService";
import { fixNumbers } from "../../core/utils";
import axios from "axios";
import Cookies from "js-cookie";

interface IProps {
  dispatch?: any;
  userData?: any;
  headerStatus?: boolean;
}

interface IState {
  uploadError: any;
  fileUpload: any;
  file: any;
  brag_id: any;
  upload_list:any;
  upload_type?: any;
  unEditable?: boolean;
  loading: boolean;
  loadingUpdate: boolean;
  userData: any;
  shebaNumber: string;
  error: Array<any>;
  dropdownOptionsUpload: any;
  contentLoading: boolean;
  base64Loading:boolean;
  inquiryLoading:boolean;
  openModal:boolean;
}
class ProfileController extends Component<IProps, IState> {
  ref: any;

  constructor(props: any) {
    super(props);
    this.ref = React.createRef();
  }
  state: IState = {
    upload_list:[],
    brag_id: this.props.userData?.brag_id,
    uploadError: [],
    fileUpload: "",
    file: "",
    contentLoading: false,
    unEditable: true,
    loading: false,
    loadingUpdate: false,
    userData: {},
    shebaNumber: "",
    error: [],
    upload_type: [],
    dropdownOptionsUpload: [],
    base64Loading:false,
    inquiryLoading:false,
    openModal:false
  };

  getDefaultUpload = async () => {
    try {
      const response = await service.limitationBrag.bragUpload();

      if (response) {
        const data = response.data.data;
        const findFieldData = (name: string) => {
          const field = data.find((item: any) => item.name === name);
          return field
            ? { default: field.default, values: field.values }
            : { default: null, values: [] };
        };

        const uploadType = findFieldData("type");

        this.setState({
          upload_type: uploadType.default,
          dropdownOptionsUpload: {
            brag_id: uploadType.values,
          },
          contentLoading: false,
        });
      }
    } catch (error: any) {
      this.setState({ contentLoading: false });
      if (error?.status === 400) {
        toast.error("خطایی رخ داده است");
      }
    }
  };

    async agentUploadList(bragId:string) {
  
      this.setState({
        contentLoading: true,
      });

      try {
        const response = await service.Agent.uploadList({
          brag_id: bragId
        });
  
        if (response?.status === 200 || response?.status === 201) {
          this.setState({
            contentLoading: false,
          });
          this.setState({
            upload_list: response?.data?.data,
            contentLoading: false,
          });
          return response;
        } else {
          this.setState({
            contentLoading: false,
          });
          return response;
        }
      } catch (err: any) {
        this.setState({
          contentLoading: false,
        });
        return null;
      }
    }


  async uploadImage(event: any) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }
    if (file.type === "image/svg+xml") {
      toast.error("آپلود فایل SVG مجاز نمی‌باشد.");
      return;
    }
    if (file.size === 0) {
      toast.error("آپلود فایل با حجم صفر مجاز نمی‌باشد.");
      return;
    }
    if (file.size > 1 * 1024 * 1024) {
      toast.error("حجم فایل نباید بیشتر از 1 مگابایت باشد.");
      return;
    }

    const reader = new FileReader();
    reader?.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({ file: reader.result });
    };

    this.setState({ fileUpload: file });
  }

  async uploadFile() {
    const {  upload_type, fileUpload } = this.state;
  
    if (!fileUpload) {
      this.setState({
        uploadError: [{ path: "fileUpload", errors: ["لطفاً یک فایل برای آپلود انتخاب کنید"] }],
      });
      return;
    }
  
    const shebaCodeSchema = yup.object({
      fileUpload: yup.mixed().required("فایل اجباری می باشد"),
      upload_type: yup.string().required("نوع سند دریافتی اجباری می باشد"),
    });
  
    try {
    this.setState({ inquiryLoading: true }); 

      await shebaCodeSchema.validate(
        { upload_type, fileUpload },
        { abortEarly: false }
      );
  
      const formData = new FormData();
      formData.append("attachments", fileUpload);
      formData.append("type", upload_type);
      formData.append("brag_id", fixNumbers(this.props.userData?.brag_id));
      formData.append("descr", "-");
  
      const response = await service.Agent.upload(formData);
  
      if (response?.status === 200 || response?.status === 201) {
      this.setState({ inquiryLoading: false }); 

        toast.success(response?.data?.message);
        this.setState({ fileUpload: null, upload_type: "", uploadError: [] , openModal:false , file: ""}); 
        await this.agentUploadList(this.props.userData?.brag_id);
      } else {
      this.setState({ inquiryLoading: false }); 

        toast.error("خطایی در آپلود رخ داد.");
      }
    } catch (err: any) {
      this.setState({ inquiryLoading: false }); 
      this.setState({
        uploadError: Array.isArray(err.inner) ? err.inner : [],
      });
    }
  }
  async getBragAgreement() {
    this.setState({ base64Loading: true })
       
    const {
      brag_id
    } = this.state;
    try {
  
      const response = await axios.post(
        `${AppConstants.base_url_api}brag-agreement/`,
        {
          license_code:brag_id
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:  `${Cookies.get('acto')}`,
          },
          responseType: "blob", 
        }
      );
      if (response) {
      
  
      this.setState({ base64Loading: false })
      try {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    // this.setState({ base64Data: url })
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "report.pdf"); // نام فایل
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
      } catch (error) {
        console.error("خطایی رخ داد:", error   );
        this.setState({ base64Loading: false })
      } 
      }else{
      this.setState({ base64Loading: false })

      }
    } catch (err: any) {
   
    }
  };
  getProfile = () => {
    return async (dispatch: any) => {
        try {
            const response = await service.User.profile();
        } catch (error: any) {
            if (error?.status === 406) {
                const data = error?.data?.message?.data || {};
                if (data && dispatch) {
                    await dispatch(userData(data)); // منتظر بمان تا dispatch کامل شود
                }
                await this.getDefaultUpload();
                await this.agentUploadList(data?.brag_id);
                this.setState({ openModal: false });
            }
        }
    };
};

  closeModal = () => {
    this.setState({openModal:false})
    this.setState({ fileUpload: "", file: "" })
   }
}
export default ProfileController;
